import { Language } from 'ha/i18n';

export function hasLanguage({ params: { lang = '' } }): boolean {
  return Object.values(Language).includes(lang.toLowerCase() as Language);
}
